import { Link } from "react-router-dom";
import { RefundData } from "../../../../types/refund";
import { NormalInfoWrapper } from "../../../tasks/styles";
import { RowsWrapper } from "../../styles";

interface RefundDetailsProps {
  data: RefundData
}

interface Detail {
  label: string,
  value: any,
}

function getIndexOfLastRow(details: Detail[]) {
  let lastValidRow = -1;
  let secondLastValidRow = -1;
  let validCount = 0;

  for (let i = 0; i < details.length; i++) {
    if (details[i].value != null) {
      secondLastValidRow = lastValidRow;
      lastValidRow = i;
      validCount++;
    }
  }

  return validCount % 2 === 0
    ? [secondLastValidRow, lastValidRow]
    : [lastValidRow];
}

export const RefundRow = ({ data }: RefundDetailsProps) => {
  const { agentApiApplication, queues } = data || {};
  const { amount, coreNumber, applicationId } = agentApiApplication || {};
  const isRefunded = queues?.["disbursed"]

  const offerDetails = [
    { label: "Amount", value: `${new Intl.NumberFormat().format(amount)} kr` },
    { label: "Link to application in Flow", value: <Link to={`/cases/case/common-process/${applicationId}`}>View Application</Link> },
    { label: "Core number", value: coreNumber },
    { label: "Refunded", value: isRefunded ? "Yes" : "No" },
  ]

  const lastIndexes = getIndexOfLastRow(offerDetails)
  const isEmpty = offerDetails.every(detail => detail.value === null || detail.value === undefined);
  if (isEmpty) return null

  return (
    <RowsWrapper className="Refund information">
      <NormalInfoWrapper $header>Refund Details</NormalInfoWrapper>
      {offerDetails.map((detail, index) => {
        if (detail.value === null || detail.value === undefined) return
        return (
          <NormalInfoWrapper key={`Refund row - ${detail.label}`} $isLast={lastIndexes.includes(index)}>
            <div>{detail.label}</div>
            <div>{detail.value}</div>
          </NormalInfoWrapper>
        )
      })}
    </RowsWrapper>
  )
}